// extracted by mini-css-extract-plugin
export default {"active":"hDPrh3s4w27ymXWigVeZ"};